"use client";
// Hoja de ayuda rápida: pasos cortos de la pantalla actual y el camino a Soporte.
import { useEffect, useRef } from "react";
import { ayudaPara } from "@/components/ayuda-rapida";
import { guardarVista } from "@/lib/navegacion";

/** Soporte es una sección del panel: se deja guardada como la vista de entrada y se abre el panel. */
const irASoporte = () => { guardarVista({ tipo: "seccion", seccion: "Soporte", sub: "soporte" }); location.assign("/panel"); };

export function AyudaRapidaPanel({ ruta, puedeEscribir, cerrar }: { ruta: string; puedeEscribir: boolean; cerrar: () => void }) {
  const ayuda = ayudaPara(ruta), cierre = useRef<HTMLButtonElement>(null);
  useEffect(() => { cierre.current?.focus(); const t = (e: KeyboardEvent) => { if (e.key === "Escape") cerrar(); }; window.addEventListener("keydown", t); return () => window.removeEventListener("keydown", t); }, [cerrar]);
  return (
    <div className="sis-ayuda-velo" onClick={cerrar}>
      <section className="sis-ayuda-hoja" role="dialog" aria-modal="true" aria-label={ayuda.titulo} onClick={(e) => e.stopPropagation()}>
        <header><h2>{ayuda.titulo}</h2><button ref={cierre} type="button" aria-label="Cerrar la ayuda" onClick={cerrar}>✕</button></header>
        <ol>{ayuda.pasos.map((p) => <li key={p.titulo}><b>{p.titulo}</b><span>{p.detalle}</span></li>)}</ol>
        {puedeEscribir
          ? <button type="button" className="sis-ayuda-soporte" onClick={irASoporte}>Escribir a Soporte</button>
          : <p className="sis-ayuda-nota">Si algo no funciona, avísale a tu coordinador.</p>}
      </section>
    </div>
  );
}
